import gql from "graphql-tag";

export const MY_LEAVE_GET_EMAILS_BY_COMPANY = gql`
  query getEmailsByCompanyList {
    getEmailsByCompanyList {
      companyCode
      type
      address
    }
  }
`;
